import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import cn from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { number, string, object, func, oneOfType, array, bool } from 'prop-types';
import CustomTable from '../CustomTable/CustomTable';
import Icon from '../Icon/Icon';
import { FMessage } from '../../hoc/IntlComponents';
import CopyContent from '../common/CopyContent';
import SplitTestLabel from '../common/SplitTestLabel';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

class FlowListItem extends Component {
  static propTypes = {
    id: number.isRequired,
    site_id: number,
    offer_id: number,
    its: number.isRequired,
    type: oneOfType([string, number]),
    title: string.isRequired,
    offers: object.isRequired,
    sites: object.isRequired,
    onFlowRemove: func.isRequired,
    onFlowCopy: func.isRequired,
    link: oneOfType([string, object]),
    flow: string,
    split_test: oneOfType([number, bool]),
  };

  static defaultProps = {
    its: 0,
    offers: {},
    sites: {},
    link: '',
    split_test: 0,
    onFlowRemove() {},
    onFlowCopy() {},
  };

  getOfferName = (offerId) => {
    const { offers } = this.props;
    return offers[offerId] ? offers[offerId].title : offerId;
  };

  isDisabled = (offerId) => {
    const { offers } = this.props;
    return offers && offers[offerId] ? offers[offerId].disabled : false;
  };

  getStreamType = (flow) => {
    if (flow === 'stream' || flow === 'tds') {
      return <FMessage id={`flows.table.type.${flow}`} />;
    }
    return '';
  };

  renderLink = () => {
    const { encId, link, flow, links = {} } = this.props;
    const { directLinkWithOutRedirect } = links;
    if (flow !== 'tds') {
      return directLinkWithOutRedirect ? (
        <a href={directLinkWithOutRedirect} target="_blank">
          {encId}
        </a>
      ) : (
        encId
      );
    } else {
      return encId;
      // return link && link.host && link.link && link.scheme ? (
      //   <a href={`${link.scheme}://${link.host}/${link.link}`} target="_blank">
      //     {link.link}
      //   </a>
      // ) : (
      //   encId
      // );
    }
  };

  getLink = () => {
    const { link, flow } = this.props;
    if (flow !== 'tds') {
      return link ? link : '';
    } else {
      return link && link.host && link.link && link.scheme
        ? `${link.scheme}://${link.host}/${link.link}`
        : '';
    }
  };

  render() {
    const {
      id,
      its,
      title,
      link,
      split_test,
      links = {},
      offer_id: offerId,
      site_id: siteId,
      is_block,
      onFlowRemove,
      onFlowCopy,
      flow,
      count,
    } = this.props;

    const toolTipPosition = count === 1 ? 'left' : 'top';

    const { directLinkWithOutRedirect, directLinkLanding } = links;

    return (
      <CustomTable.Row className={cn('flows-list-item', { disabled: this.isDisabled(offerId) })}>
        <CustomTable.Cell>{this.renderLink()}</CustomTable.Cell>
        <CustomTable.Cell>{title}</CustomTable.Cell>

        <CustomTable.Cell>
          <Moment format="DD/MM/YYYY" unix>
            {its}
          </Moment>
        </CustomTable.Cell>

        <CustomTable.Cell className="text-center">
          <div className="flows-copy-content-wrapper">
            {/* {link && (
              <CopyContent
                content={this.getLink()}
                iconType="link-2"
                copyMessageId="flows.table.click-link"
                tooltipMessageId="flows.table.click-link.copy"
                tooltipTargetId={`flow_link_${id}`}
              />
            )} */}
            {directLinkWithOutRedirect && (
              <CopyContent
                content={directLinkWithOutRedirect}
                iconType="link-2"
                copyMessageId="flows.table.click-link"
                tooltipMessageId="flows.table.direct-link.copy"
                tooltipTargetId={`flow_direct_link_${id}`}
              />
            )}
            {directLinkLanding ? (
              <CopyContent
                content={directLinkLanding}
                iconType="link-2"
                copyMessageId="flows.table.click-link"
                tooltipMessageId="flows.table.direct-link.copy"
                tooltipTargetId={`flow_parked_link_${id}`}
              />
            ) : null}
            {split_test > 0 && (
              <SplitTestLabel
                style={{ marginLeft: '8px', marginBottom: '4px' }}
                tooltipTargetId={`flow_split_test_label_${id}`}
              />
            )}
          </div>
        </CustomTable.Cell>

        {/* <CustomTable.Cell>{this.getStreamType(flow)}</CustomTable.Cell> */}

        {siteId || siteId === 0 ? (
          <CustomTable.Cell>
            <Link to={`/offers/${offerId}`}>{this.getOfferName(offerId)}</Link>
          </CustomTable.Cell>
        ) : (
          <CustomTable.Cell />
        )}

        <CustomTable.Cell>
          <ul className="flow-statuses text-right list-inline no-margin">
            {this.isDisabled(offerId) && (
              <li className="list-inline-item">
                <Icon id={`blocked_offer_${id}`} type="warning" />

                <UncontrolledTooltip
                  placement={toolTipPosition}
                  trigger="legacy hover"
                  modifiers={{
                    offset: {
                      offset: '0, 5px',
                    },
                  }}
                  target={`blocked_offer_${id}`}
                >
                  <FormattedMessage
                    id="flows.table.offer-disabled"
                    defaultValue="Offer disabled! Please redirect your traffic to another offer!"
                  />
                </UncontrolledTooltip>
              </li>
            )}

            {is_block > 0 && (
              <li className="list-inline-item">
                <Icon id={`blocked_flow_${id}`} type="lock" />

                <UncontrolledTooltip
                  placement={toolTipPosition}
                  trigger="legacy hover"
                  modifiers={{
                    offset: {
                      offset: '0, 5px',
                    },
                  }}
                  target={`blocked_flow_${id}`}
                >
                  <FormattedMessage id="flows.table.locked" defaultValue="Flow is blocked!" />
                </UncontrolledTooltip>
              </li>
            )}
          </ul>
        </CustomTable.Cell>

        <CustomTable.Cell>
          <Link
            to={`/statistics?flows=${id}`}
            role="button"
            className="flow-control flow-stats"
            id={`flow_stats_${id}`}
          >
            <SVG
              src={`${STATIC_PATH}/img/action-icons/flow_statistics.svg`}
              height="20"
              width="20"
              cacheRequests
            />
          </Link>
          <UncontrolledTooltip
            placement={'left'}
            trigger="legacy hover"
            target={`flow_stats_${id}`}
            delay={250}
          >
            <FormattedMessage id="flows.table.flow_stats" defaultValue="Statistics" />
          </UncontrolledTooltip>
        </CustomTable.Cell>

        <CustomTable.Cell>
          {/* !directLinkWithOutRedirect &&
        !directLinkLanding &&  */}
          {flow === 'stream' && !this.isDisabled(offerId) && (
            <>
              <a
                className="flow-control copy-flow"
                role="button"
                aria-label="Copy Flow"
                onClick={() => onFlowCopy(id)}
                id={`copy_flow_link_${id}`}
              >
                <SVG
                  src={`${STATIC_PATH}/img/action-icons/copy_flow.svg`}
                  height="20"
                  width="20"
                  cacheRequests
                />
              </a>
              <UncontrolledTooltip
                placement={'left'}
                trigger="legacy hover"
                target={`copy_flow_link_${id}`}
                delay={250}
              >
                <FormattedMessage id="flows.table.copy_flow" defaultValue="Copy" />
              </UncontrolledTooltip>
            </>
          )}
        </CustomTable.Cell>

        <CustomTable.Cell className="table-controls">
          <Link
            to={flow === 'tds' ? `/tools/streams/tds/${id}` : `/tools/flows/${id}`}
            className="flow-control edit-flow"
            role="button"
            aria-label="Edit Flow"
            id={`edit_flow_link_${id}`}
          >
            <SVG
              src={`${STATIC_PATH}/img/action-icons/flow_edit.svg`}
              height="20"
              width="20"
              cacheRequests
            />
          </Link>
          <UncontrolledTooltip
            placement={'left'}
            trigger="legacy hover"
            target={`edit_flow_link_${id}`}
            delay={250}
          >
            <FormattedMessage id="flows.table.edit_flow" defaultValue="Edit" />
          </UncontrolledTooltip>
        </CustomTable.Cell>

        <CustomTable.Cell className="table-controls">
          <a
            className="flow-control remove-flow"
            role="button"
            aria-label="Remove Flow"
            onClick={() => onFlowRemove(id)}
            id={`remove_flow_link_${id}`}
          >
            <SVG
              src={`${STATIC_PATH}/img/action-icons/trash.svg`}
              height="20"
              width="20"
              cacheRequests
            />
          </a>
          <UncontrolledTooltip
            placement={'left'}
            trigger="legacy hover"
            target={`remove_flow_link_${id}`}
            delay={250}
          >
            <FormattedMessage id="flows.table.remove_flow" defaultValue="Delete" />
          </UncontrolledTooltip>
        </CustomTable.Cell>
      </CustomTable.Row>
    );
  }
}

const mapStateToProps = ({ streams }) => ({
  offers: streams.settings.offers,
  sites: streams.settings.sites,
});

export default connect(mapStateToProps)(FlowListItem);
